import { Spinner } from "@fluentui/react";
import { useEffect, useState } from "react";
import "./Loadable.scss";

export interface ILoadableProps {
  isLoading: boolean;
  content: JSX.Element;
}

const Loadable = (props: ILoadableProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    setLoading(props.isLoading);
  }, [props.isLoading]);

  return (
    <div className="loadable-main-wrap">
      {loading && (
        <div className="loadable-spinner-wrap">
          <Spinner label="Attendere..." labelPosition="bottom" />
        </div>
      )}
      {!loading && <div>{props.content}</div>}
    </div>
  );
};

export default Loadable;
